import { render, staticRenderFns } from "./xxzykszztyx.vue?vue&type=template&id=1507d01e&scoped=true&"
import script from "./xxzykszztyx.vue?vue&type=script&lang=js&"
export * from "./xxzykszztyx.vue?vue&type=script&lang=js&"
import style0 from "./xxzykszztyx.vue?vue&type=style&index=0&id=1507d01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507d01e",
  null
  
)

export default component.exports